import React from "react";
import Banner from "../components/banner";
import ErrorComponent from "../components/partnerError";
import {
	Row,
	Col,
	Card
} from 'kepler';

import { parseMessages } from '../../utilityHelper';

const bodyTagData = $("body").data();

const profileMsg = parseMessages("partner/components/profile");
export default class PartnerProfile extends React.Component {
  constructor(props) {
		super(props);
		this.state = {
			profileData:bodyTagData.body.profileResults,
			missionarea:bodyTagData.body.missionarea ? bodyTagData.body.missionarea[0] : '',
			errorType:bodyTagData.body.errorType
		}
	}

  render() {
    const errorType = this.state.errorType;
    let website_url = this.state.profileData && this.state.profileData.website_url ? this.state.profileData.website_url : '';
    let taxIdentifier = this.state.profileData && (this.state.profileData.address.country_code == 'GB') ? 'Charity Commission number' : this.state.profileData && (this.state.profileData.address.country_code == 'AU') ? 'ABN' : this.state.profileData && (this.state.profileData.address.country_code == 'CA') ? 'CRA number' : 'EIN';
    if (!errorType) {
      return (
        <div>
          <Banner charityName  = {this.state.profileData.name} pageName={bodyTagData.body.pageName}/>
          <div className="container">
            <div id="profileWrapper">
             	<section className="profileSection">
             		<Row>
					<Col xs="100%" sm="50%" lg="50%">
						<Card>
                            <Row className="profileData">
                                <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.nonprofit_id ? '' : 'grey'}>
                                    {profileMsg.nonprofitid}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.nonprofit_id}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%">
                                    {profileMsg.name}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.name}
                                </Col>
                               <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.email ? '' : 'grey'}>
                                    {profileMsg.emailaddress}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.email}
                                </Col>
                               <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.ein ? '' : 'grey'}>
                                    {taxIdentifier}
                                </Col>
                               <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.ein}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%" className={(this.state.missionarea && this.state.missionarea.name) ? '' : 'grey'}>
                                    {profileMsg.mission}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.missionarea && this.state.missionarea.name}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.description ? '' : 'grey'}>
                                    {profileMsg.description}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.description}
                                </Col>
                            </Row>        
             			</Card>
             		</Col>
             		<Col xs="100%" sm="50%" lg="50%">
             			<Card>
                            <Row className="profileData">
                                <Col xs="50%" sm="50%" lg="33%">
                                    {profileMsg.givingfundstatus}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.charity_type == 'GUIDESTAR' ? profileMsg.unenrolled : profileMsg.enrolled}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.logo_url ? '' : 'grey'}>
                                    {profileMsg.logo}
                                </Col>
                                 <Col xs="50%" sm="50%" lg="67%">
                                    <img width="200px" src={this.state.profileData.logo_url} />
                                </Col>
                               <Col xs="50%" sm="50%" lg="33%">
                                    {profileMsg.registrationdate}
                                </Col>
                                 <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.registration_date}
                                </Col>
                               <Col xs="50%" sm="50%" lg="33%">
                                    {profileMsg.lastmodifieddate}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.last_modified_date}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%" className={this.state.profileData.address.phone ? '' : 'grey'}>
                                    {profileMsg.phone}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.address.phone}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%">
                                    {profileMsg.address}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {this.state.profileData.address.line1} <br/>
                                    {this.state.profileData.address.line2 && this.state.profileData.address.line2} 
                                    {this.state.profileData.address.line2 && <br/>} 
                                    {this.state.profileData.address.city}, {this.state.profileData.address.state}, {this.state.profileData.address.postal_code}
                                </Col>
                                <Col xs="50%" sm="50%" lg="33%" className={(website_url) ? '' : 'grey'}>
                                    {profileMsg.website}
                                </Col>
                                <Col xs="50%" sm="50%" lg="67%">
                                    {website_url}
                                </Col>
                            </Row>
             			</Card>
             		</Col>
             		</Row>
             		
             	</section>
            </div>
          </div>
        </div>
      );
    } else {
        return (<div><ErrorComponent errorType={errorType}/></div>);
    }
  }
}




// WEBPACK FOOTER //
// ./partner/components/profile.js